import React from 'react'

function InductionINN6() {
  return (
    <embed src="\pdfs\E1.1.8_IN-N6_Induction_outlet_with_preset_discharge_direction_04.2013_kr.pdf" width="100%" height="2100px" />
  )
}

export default InductionINN6